// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //  serverURL :  'http://localhost:44334/api',
  //  serverURLLogin : "http://localhost:44334"
  //  serverURL: "http://203.82.54.155:8088/api",
  //  serverURLLogin: "http://203.82.54.155:8088",
  // serverURL: "http://menzies.ras.com.pk/Services/api",
  // serverURLLogin: "http://menzies.ras.com.pk/Services"
  // serverURL: "http://ras.cargoplus.com.pk/Services/api",
  // serverURLLogin: "http://ras.cargoplus.com.pk/Services"

  serverURL: "https://www.menzies-ras.com.pk/Services/api",
  serverURLLogin: "https://www.menzies-ras.com.pk/Services/"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
